import axios from './config/config'
const defaultRoute = 'usuario/'
export default{
    list:()=>{
        return axios.get(`${defaultRoute}`)
    },
    create:(user)=>{
        return axios.post(defaultRoute,user)
    },
    update:(id, user)=>{
        return axios.put(defaultRoute+id, user)
    },
    remove:(id)=>{
        return axios.delete(defaultRoute+id)
    },
    
} 